// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"166":"98a400584b350421fd3c","494":"2df975bc9a9e5a0bb116"}[chunkId] + ".js";
};